module.exports = __webpack_public_path__ + "img/NO.e217a961.gif";